export const COMPOSITE_LAYER = 'COMPOSITE_LAYER';
export const compositeLayer = ({
  locked,
  geom,
  unit,
  label,
  key,
  layers = [],
  default: def,
}) => ({
  type: COMPOSITE_LAYER,
  locked,
  geom,
  unit,
  label,
  key,
  layers,
  default: def,
});

export const CATEGORY_RANGE = 'CATEGORY_RANGE';
export const categoryRange = ({
  locked,
  discrete,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  exclude = [],
  values = [],

  forceDots = false,
  style = 'fill',
  colorScheme,
  orLess,
  dasharray,
  lineWidth,
  opacity,

  map,
  download,
  default: def,
}) => ({
  type: CATEGORY_RANGE,

  locked,
  discrete,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  exclude,
  values,

  forceDots,
  style,
  colorScheme,
  orLess,
  dasharray,
  lineWidth,
  opacity,

  map,
  download,
  default: def,
});

export const CATEGORY = 'CATEGORY';
export const category = ({
  locked,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  exclude = [],

  map,
  forceDots = false,
  style = 'fill',
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  download,
  default: def,
}) => ({
  type: CATEGORY,

  locked,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  exclude,

  forceDots,
  style,
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  map,
  download,
  default: def,
});

export const DATA_STREAM_CATEGORY = 'DATA_STREAM_CATEGORY';
export const dataStreamCategory = ({
  key,
  label,
  timeline,
  filterString,
  source,
  dataStreamField,
  exclude = [],
  unit,

  map,
  values,
  forceDots = false,
  style = 'fill',
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  download,
  default: def,
}) => ({
  type: DATA_STREAM_CATEGORY,
  dataStreamField,
  label,
  timeline: timeline
    ? {
        ...timeline,
        key: `${key}+ds${dataStreamField}`,
      }
    : null,
  source,

  filterString: filterString || '',
  layerOptionsFilterString: `data_stream_field_id=data_point%3A${dataStreamField}${
    filterString ? `&${filterString}` : ''
  }`,

  key: `${key}+ds${dataStreamField}`,
  layerOptionsKey: `string_value+ds${dataStreamField}`,
  exclude,
  unit,

  forceDots,
  style,
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  map,
  values,
  download,
  default: def,
});

export const DATA_STREAM_CATEGORY_RANGE = 'DATA_STREAM_CATEGORY_RANGE';
export const dataStreamCategoryRange = ({
  key,
  label,
  timeline,
  filterString,
  source,
  dataStreamField,
  exclude = [],
  unit,

  map,
  values,
  forceDots = false,
  style = 'fill',
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  download,
  default: def,
}) => ({
  type: DATA_STREAM_CATEGORY_RANGE,
  dataStreamField,
  label,
  timeline: timeline
    ? {
        ...timeline,
        key: `${key}+ds${dataStreamField}`,
      }
    : null,
  source,

  filterString: filterString || '',
  layerOptionsFilterString: `data_stream_field_id=data_point%3A${dataStreamField}${
    filterString ? `&${filterString}` : ''
  }`,

  key: `${key}+ds${dataStreamField}`,
  layerOptionsKey: `string_value+ds${dataStreamField}`,
  exclude,
  unit,

  forceDots,
  style,
  dasharray,
  lineWidth,
  colorScheme,
  opacity,

  map,
  values,
  download,
  default: def,
});

export const RANGE = 'RANGE';
export const range = ({
  locked,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  values,

  forceDots = false,
  colorScheme,
  orLess,
  style = 'fill',
  dasharray,
  lineWidth,
  opacity,

  map,
  download,
  default: def,
}) => ({
  type: RANGE,

  locked,
  geom,
  unit,
  label,
  timeline,
  filterString,
  source,
  key,
  values,

  colorScheme,
  orLess,
  style,
  dasharray,
  lineWidth,
  opacity,
  forceDots,

  map,
  download,
  default: def,
});

export const DATA_STREAM_RANGE = 'DATA_STREAM_RANGE';
export const dataStreamRange = ({
  key,
  label,
  timeline,
  filterString,
  source,
  unit,
  values,
  dataStreamField,

  forceDots = false,
  colorScheme,
  orLess,
  style = 'fill',
  dasharray,
  lineWidth,
  opacity,

  map,
  download,
  default: def,
}) => ({
  type: DATA_STREAM_RANGE,

  label,

  dataStreamField,
  timeline: timeline
    ? {
        ...timeline,
        key: `${key}+ds${dataStreamField}`,
      }
    : null,

  filterString: filterString || '',
  layerOptionsFilterString: `data_stream_field_id=data_point%3A${dataStreamField}${
    filterString ? `&${filterString}` : ''
  }`,
  source,
  key: `${key}+ds${dataStreamField}`,
  layerOptionsKey: `number_value+ds${dataStreamField}`,
  unit,
  values,

  colorScheme,
  orLess,
  style,
  dasharray,
  lineWidth,
  opacity,
  forceDots,

  map,
  download,
  default: def,
});
